import { handleEmailClick } from '@/utils/handleMailto';
import { isStringWithValue } from '@/utils/helpers/isStringWithValue';
import { ISbLink } from '@/utils/interfaces/common';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

interface IProps {
  link: ISbLink;
  newTab?: boolean;
  passHref?: boolean;
  goOnTop?: boolean;
  className?: string;
}

export const SbLinkWithAnchor: React.FC<IProps> = ({ link, children, goOnTop, className, ...props }) => {
  const router = useRouter();
  const [urlLocale, setUrlLocale] = useState<string | undefined>(router.locale);
  const { cached_url, email } = link;

  let href = '/';

  switch (link.linktype) {
    case 'url':
      href = cached_url || '/';
      break;
    case 'email':
      href = `mailto:${email}`;
      break;
    case 'story':
      href = `/${cached_url}`;
      break;
    default:
      break;
  }

  useEffect(() => {
    if (isStringWithValue(cached_url)) {
      const linkLocale = cached_url.split('/')[0];
      if (new RegExp('en-').test(linkLocale)) {
        setUrlLocale(linkLocale);
      }
    }
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    if (goOnTop) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (link.linktype === 'email' && email) {
    return (
      <button onClick={(e) => {
        if (goOnTop) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          handleEmailClick(email);
        }
      }} className={className} {...props}>
        {children}
      </button>
    );
  }

  if (props.newTab) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={className} {...props}>
        {children}
      </a>
    );
  }

  return (
    <a
      href={href}
      onClick={(e) => {
        if (goOnTop) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }}
      className={className}
      {...props}
    >
      {children}
    </a>
  );
};
